module.exports = __webpack_public_path__ + "static/media/trans-fat.b198424a.png";